<template>
  <div id="new-notification">
    <PageTitle title="notificatie toevoegen" description="Een melding wordt via een pushbericht verzonden. Gebruikers kunnen op hun smartphone zelf instellen of ze deze ontvangen of niet. De melding komt in de app ook in de notificatie lijst terug."></PageTitle>
    <form @submit.prevent>
      <div class="form-group float-right">
        <button @click="cancel" class="btn btn-light mr-2">Annuleren</button>
        <button @click="saveItem()" class="btn btn-success">Nu verzenden</button>
      </div>
      <div class="form-group">
        <label for="title">Titel</label>
        <input type="text" class="form-control" placeholder="Titel" v-model="title" />
      </div>
      <div class="form-group">
        <label for="section">Bericht</label>
        <textarea class="form-control" id="section" v-model="content" rows="5"></textarea>
      </div>
      <!-- <div class="row mb-2">
        <div class="col">
          <label for="section">verzend datum</label>
          <input type="date" class="form-control" v-model="startdate" />
        </div>
        <div class="col">
          <label for="section">verzend tijd</label>
          <input type="time" class="form-control" v-model="starttime" />
        </div>
      </div> -->

      <Selectoptions v-on:setOptions="setOptions"  :checkedEstablishments="checkedEstablishments" :checkedPositions="checkedPositions"></Selectoptions>
    </form>
  </div>
</template>

<script>
const fb = require("@/firebaseConfig.js");
import PageTitle from "@/components/PageTitle.vue";
import Selectoptions from "@/components/Selectoptions.vue";

export default {
  name: "new-notification",
  components: {
    PageTitle,
    Selectoptions
  },
  data() {
    return {
      title: "",
      content: "",
    //  startdate: this.getToday(),
    //  starttime: "09:00",
      checkedEstablishments: [],
      checkedPositions: [],
    };
  },
  methods: {
      getToday(){
        var d = new Date()
        return d.getFullYear() + "-" + (d.getMonth()+1 < 10 ? "0" : "") + (d.getMonth()+1) + "-" + (d.getDate() <10 ? "0" : "") + d.getDate()
        //console.log(ret)
        //return ret
      },
    setOptions(data) {
      this.checkedPositions = data.checkedPositions;
      this.checkedEstablishments = data.checkedEstablishments;
    },
    saveItem() {
      var now = new Date();
     // var sd = this.startdate + "T" + (this.starttime == '' ? "00:00" : this.starttime);
      fb.notificationsCollection
        .add({
          type: "notification",
          refid: "self",
          date: now,
          created_by: this.$cookies.get("user"),
          title: this.title,
          message: this.content,  
          establishments:
            this.checkedEstablishments.length > 0
              ? this.checkedEstablishments
              : null,
          positions:
            this.checkedPositions.length > 0 ? this.checkedPositions : null,
            hidden: false,
            company: this.$cookies.get("company"),
            sendPush: true,
           // delay: sd
        }).then(()=>{
          this.$router.push("/notifications");
        })
        .catch(error => console.log(error));
    },
    cancel() {
        this.$router.go(-1);
    },
  },
};
</script>